import Bars from './bars';
import './styles.css';

export default function Scores({
  data = [],
  size = '',
  maxScore,
  isBigScores = false,
  alignBarTitle = 'right',
  labels = [],
  detailsButtonText,
  onDetailsButtonClick,
  isDetailsButtonLoading = false
}) {
  return (
    <div className={`score-pages-analysis ${size}`}>
      <div className='scores-body'>
        {
          labels.length > 0 &&
            <ul className="scores-data-labels">
              {
                labels.map((label, index) => (
                  <li key={index}><span className="label-color" style={{backgroundColor: label.color}}></span>{label.name}</li>
                ))
              }
            </ul>
        }
        <div className="scores-data">
          {
            data && data.map((scoresBlock, index) => (
              <div key={index} className="scores-block">
                {
                  scoresBlock.title &&
                    <div className="scores-block-title-wrapper">
                      <h3 className="scores-block-title">{scoresBlock.title}</h3>
                      {
                        scoresBlock.subtitle &&
                          <h4 className="scores-block-subtitle">{scoresBlock.subtitle}</h4>
                      }
                    </div>
                }
                <Bars 
                  bars={scoresBlock.bars}
                  label={scoresBlock.barsLabel}
                  maxScore={maxScore}
                  isBigScores={isBigScores}
                  alignBarTitle={alignBarTitle}
                />
              </div>
            ))
          }
        </div>
        {
          detailsButtonText && onDetailsButtonClick &&
            <button className={`scores-details-button ${isDetailsButtonLoading ? 'loading' : ''}`} onClick={onDetailsButtonClick}>
              {!isDetailsButtonLoading && detailsButtonText}
            </button>
        }
      </div>
    </div>
  );
}
